import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const printMargins = (user: User, mrgid: string) => {
	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getmarginscalcreport",
		params: {
			userid: user.userId,
			mrgid,
		},
	});
};

export default printMargins;
